// src/pages/RecruitmentAnalytics/RecruiterDetail.tsx
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../api/client';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface RecruiterFunnel {
  recruiterId: string;
  vacancyCount: number;
  funnel: {
    applications: number;
    screenings: number;
    interviews: number;
    offers: number;
    hires: number;
    rejections: number;
  };
}

const RecruiterDetail: React.FC = () => {
  const { recruiterId } = useParams<{ recruiterId: string }>();
  const navigate = useNavigate();
  const [data, setData] = useState<RecruiterFunnel | null>(null);
  const [recruiterName, setRecruiterName] = useState<string>('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        // Загружаем данные воронки и имя рекрутера
        const [funnelRes, usersRes] = await Promise.all([
          api.get(`/recruiter-performance/funnel/${recruiterId}`),
          api.get('/users/company-users')
        ]);
        setData(funnelRes.data);

        const users = usersRes.data;
        const user = users.find((u: any) => u.id === recruiterId);
        setRecruiterName(user?.name || `Рекрутер (${recruiterId})`);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [recruiterId]);

  if (loading) return (
    <div style={{ padding: 40, textAlign: 'center' }}>
      <Loader2 size={30} />
    </div>
  );
  if (!data) return <p>Нет данных</p>;

  const chartData = [
    { stage: 'Заявки', value: data.funnel.applications },
    { stage: 'Скрининг', value: data.funnel.screenings },
    { stage: 'Интервью', value: data.funnel.interviews },
    { stage: 'Офферы', value: data.funnel.offers },
    { stage: 'Наймы', value: data.funnel.hires },
    { stage: 'Отказы', value: data.funnel.rejections }
  ];

  return (
    <div style={{ padding: '0 20px 20px 20px' }}>
      <button
        onClick={() => navigate('/app/recruitment-analytics/performance')}
        style={{
          marginBottom: 20,
          background: 'rgba(255,255,255,0.5)',
          border: '1px solid #2575fc',
          borderRadius: 30,
          padding: '8px 16px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: 6
        }}
      >
        <ArrowLeft size={16} /> Назад к списку
      </button>
      <h2>Воронка: {recruiterName}</h2>
      <p>Всего вакансий: {data.vacancyCount}</p>
      <div style={{ width: '100%', height: 300 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="stage" />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Bar dataKey="value" fill="#6a11cb" radius={[8,8,0,0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default RecruiterDetail;